/**
 * App2 Shared Contexts
 *
 * Re-export contexts for App2 with React Query integration
 */
export {LocaleContext, LocaleProvider, resolveLocale, SUPPORTED_LOCALES} from "./LocaleContext";
export type {SupportedLocale, LocaleContextUpdate} from "./LocaleContext";
export {
	App2NotificationContext,
	App2NotificationProviderInner,
	App2NotificationSeverity
} from "./App2NotificationContext";
export {
	EnsureAccountContext,
	EnsureAccountProvider,
	useEnsureAccount
} from "./EnsureAccountContext";
export {
	AccessRestrictedContext,
	AccessRestrictedProvider,
	TRAINING_ACCESS_FORBIDDEN_MESSAGE,
	isTrainingAccessForbidden
} from "./AccessRestrictedContext";
export type {EnsureAccountStatus} from "./EnsureAccountContext";
export type {App2Notification, App2NotifyProps, App2NotificationContextValue} from "./App2NotificationContext";
export {
	ContentContainerContext,
	useContentContainerRef
} from "./ContentContainerContext";
export {
	PointsEarnedFloaterProvider,
	useTriggerPointsEarnedFloater
} from "./PointsEarnedFloaterContext";

